import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left-nav.field-active",
  "use": "icon-left-nav.field-active-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left-nav.field-active\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.4167 1C14.7388 1 15 1.26117 15 1.58333V14.4167C15 14.7388 14.7388 15 14.4167 15H1.58333C1.26117 15 1 14.7388 1 14.4167V1.58333C1 1.26117 1.26117 1 1.58333 1H14.4167ZM14 2H2V14H14V2ZM4 4H12V6L11.3333 5H8.5V12H7.5V5H4.6685L4 6V4Z\" fill=\"#507AFE\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol